export const kebabCase = (string: string) =>
  string
    .trim() // Trim leading and trailing whitespace
    .replace(/[^\w\s]/g, "") // Remove punctuation
    .replace(/([a-z])([A-Z])/g, "$1-$2") // Add dash between camelCase
    .replace(/[\s_]+/g, "-") // Replace whitespace or underscores with dash
    .toLowerCase()
